module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-One.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-5"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("CHAPTER ONE")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "sub"
  }, [_vm._v("Three years earlier")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("“W")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("E")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("HAVE")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("TO")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("TALK")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Glancing from the baby in her arms to the man standing in the doorway of their bedroom, Lynn nodded. Brandon had been acting odd since before Kara was born, moving into the spare bedroom ostensibly so his tossing and turning didn’t make Lynn more uncomfortable than she already was.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And now five weeks after their daughter’s birth, he was still using the spare room.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Come on in.” She patted the bed beside her. The baby had just finished her 9:00 p.m. feeding and should sleep until midnight. Lynn had napped that afternoon. She could manage without more rest. And even if she couldn’t, she would. Brandon was her life—and was obviously having a hard time adjusting to sharing their world.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At least, she prayed that was the problem.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He joined her on the bed, and she placed his pillow against the headboard so he could sit propped up beside her. Ignoring the pillow, he turned his gaze to Kara and remained seated on the edge of the bed. The sadness in his smile scared her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Brandon? What’s going on?” They’d been best friends since the ninth grade. Knew everything about each other.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He looked from her to Kara. “She’s perfect, Lynn. Everything we hoped and more...”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But? She heard it there. His chin taut, he stared silently at the baby.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You want to hold her?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Nodding, he reached for the soft, blanketed bundle sleeping against her. Cradling Kara’s body easily on one arm, the baby’s head safely nestled between his biceps and chest, Brandon looked comfortable, natural, as though this was his fifth child, not his first.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His gentleness, as always, touched her deeply.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She’s great, isn’t she?” he said, his voice thick with emotion. Reminding her of their wedding day, of standing at the front of the church that was filled to capacity with their friends and loved ones and hearing the catch in his voice as he vowed to love her forever. There’d been no mistaking his sincerity. Listening to him, she’d known very clearly that he spoke a truth beyond words. Brandon’s love was real. The kind that came from someplace more powerful than the human mind or heart. From that point on she’d never worried that they’d make it. She’d known their marriage was safe.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Taking comfort in the memory, Lynn smiled. Nodded. “Yeah,” she said, loving the sight of her engineer husband holding their infant daughter. “We made a beautiful baby, Bran, just like we always said we would.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Looking at Brandon, she waited for him to raise his eyes to her—for their eyes to meet in the silent communication that had been their gift even in high school. The private smile that soothed her deepest fears. Or made her heart race, depending on the moment.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Brandon didn’t look up. And her heart raced. With fear. “Hon, what’s the matter?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Had Kara’s advent into their lives created a gap between them? She’d read about the possibility. About husbands feeling rejected, neglected, a little jealous even.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She hardly ever cries,” he said. “I expected a lot more crying.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’re lucky she’s not colicky.” Any other time Lynn would have been happiest sitting with Brandon, talking about their baby.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Diaper changing is a breeze, too,” he said. From day one Brandon had insisted on being a full contributing partner in their daughter’s life. Apart from the feedings that, biologically, he couldn’t manage. “A lot easier than those plastic dolls they made us practice on.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’d knocked the baby stand-in onto the floor the first time he’d tried to get the slippery disposable diaper fastened around it. She grinned, remembering. He didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Kissing the top of the sleeping baby’s head, Brandon transferred their daughter gently back to Lynn, still not meeting her gaze.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("If she didn’t know better, she’d think he’d just said goodbye.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Feeling desperate, she said, “I was thinking maybe we should plan a night out, just the two of us, next weekend. It’s my six-week mark.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The doctor had said they could start having sex again at six weeks postbirth.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Lynn, we need to talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Suddenly she didn’t want to continue with her attempt to draw him out. She was tired. Postpartum.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And...Brandon was struggling. Of course she had to listen. Just like he always listened to her. Every time.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was waiting. He still wasn’t talking. She drew strength from the baby in her arms. Those sweet little lips. The eyelids that were closed to a world that could be so confusing at times. Flushed cheeks and little hands clenched into fists, even in rest. “Do you still love me, Bran?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His gaze shot to hers. Finally. “You know I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He looked away immediately, but that depth of emotion was there in his voice again. His words trembled with it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He wasn’t a macho man’s man, like her little sister Katie’s ex-husband had been. But Brandon had never lifted a hand to her, either, or attempted to control her, as Katie’s ex had done to Katie.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Taking Brandon’s hand in hers, she held it between them on the bed, focusing wholly on him while the baby lay sleeping against her breast. “And you know I love you,” she told her husband of eight years. “We’ll be fine, Bran, just please tell me what’s bothering you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As she said the words, fear struck anew. The one thing that had always made her and Brandon so good together was their ability to talk things out. They’d always been able to tell each other anything. And everything. Until then.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We aren’t going to be fine, Lynn.” It was the tears in his eyes, when he finally held her gaze, that cut through her, far more than the death knell in his words. Words could change.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His sandy-blond hair, short and pristine, just as he’d always liked it, made him seem vulnerable to her in that moment. Exposed. The rest of him—his tight, in-shape, average-height body—just seemed dear.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Laying the baby in the basinet beside the bed, she moved over on the mattress to sit directly facing her husband. “Are you sick, Brandon?” Had someone given him a frightening prognosis? Just now, when they were embarking on the challenge of a lifetime with their new offspring to raise? “You know doctors aren’t always right, hon. Whatever it is, we’ll deal with it. Get second opinions and treatment...” If she just kept talking everything would be all right. She was a nurse. She’d nurse him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("With a finger against her lips, Brandon shook his head. “You can’t fix this one, babe.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Babe. He hadn’t called her that in a while. She hadn’t realized how much she’d missed it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re scaring me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m scaring me, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Is it cancer?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Whatever was wrong, it was so awful that her husband didn’t know how to tell her about. So she’d help him. Guess all night if she had to. She’d said they’d get through it together and they would. She’d show him. She had enough faith for both of them. They just had to—")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, it’s not cancer,” Brandon said, shifting so that no part of him was touching any part of her. The movement was subtle. Moving a knee. But she noticed. “I’m not sick,” he added.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Then what?” His expression, no matter how hard she studied it, told her nothing. Except that he was hurting.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She racked her brain, trying to think of anything that had happened, anything she might have missed. Tried to figure out when the problem had started. And still drew blanks.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It had to have something to do with Kara. Everything had been fine...normal...until shortly before the baby was born.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The baby was fine. Not only had all the doctors said so, but as a nurse, Lynn would know if something was wrong with her infant daughter. Kara had a healthy appetite. Slept well. And, as her father had just pointed out, didn’t cry much at all.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was fine. Kara was fine. Which, in her mind, only left one other possibility. “There’s another woman.” While she’d been fat and pregnant, and uncomfortable and unable to have sex, he’d met someone else....")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No! Whatever else happens, Lynnie, you always have been and always will be the only woman I ever wanted or had sex with.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There was no mistaking the truth in those words. They spoke straight to her heart. Breathing a little easier, Lynn reached for his hand again. “Just tell me, hon.” They were a team. Partners. For better or worse. “Things always seem worse until you get them out.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His family was close by. And hers had visited twice since the baby’s birth. They’d help with whatever the problem was.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Maybe that was it. Maybe he was tired of both sets of parents camping out on their doorstep now that Kara was there.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Please, Brandon. You’re making me crazy with worry. What’s wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She braced herself. Knew, when he met and held her gaze, that her life was about to change forever. And still wasn’t prepared for his reply.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m gay.”")]), _vm._v(" "), _c('p', {
    staticClass: "subtb"
  }, [_vm._v("Present")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("T")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("HIRTY")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("-")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("EIGHT")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("-")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("YEAR")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("-")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("OLD")]), _vm._v(" Grant Bishop wasn’t an emotional guy. He was a busy guy—too busy to get tangled up in things he couldn’t control. Except for the things he couldn’t let go.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He couldn’t let go of Darin’s condition.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Sitting in the silence of his older brother’s hospital room that balmy February morning, he rested one ankle on his knee and beat out the rhythm playing over and over in his brain. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Da da dah. Da da dah. Da da dah. Da da dah.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dr. Zimmer’s Tuesday-morning rounds were at seven-thirty. Grant wanted to be at a job site across town by nine so he could be back to make sure Darin got up in his chair for lunch. As long as his brother cooperated, he should be able to have Darin back home the next day.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Assuming the doctor told him the previous day’s surgery had gone as well as he’d thought. That Darin was responding as expected. His forty-four-year-old brother had still been groggy from the anesthetic the night before when Grant, after spending fourteen hours at the hospital, had finally gone home to shower and get some sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Darin, with a big patch of gauze taped over one side of his head, didn’t look much different nine hours later.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("More than two nights in the hospital was going to be a financial hardship. But if Darin wasn’t ready to go home Wednesday morning, they’d manage. He’d paid off the loan against his landscaping business and could borrow again if he had to.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And if there was a long-term problem? If the surgery hadn’t been successful? If the infection that had formed around the bit of irremovable stingray barb lodged in his brother’s brain was still active?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("If Darin experienced any of the numerous side effects that could have resulted from the craniotomy itself?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Hands clasped, he pounded his thumbs together, keeping the beat with the rhythm rocking his foot.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Darin was going to be just fine. The brothers had been dealing with this—Darin’s accident—for seventeen years, and things always worked out.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Maura, the sixty-year-old widow next door, checked in on Darin for Grant on the rare days his brother couldn’t accompany him to the job site, in exchange for handyman work whenever anything needed fixing at her place. She was all set to nurse Darin through the two weeks postsurgery the doc had said it would take before his brother was able to return to work.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Arrangements had been made. Details tended to.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was 7:40 and the doctor was late. Standing, hands tucked into the pockets of his jeans, Grant walked to the door of his brother’s room, pulled it open and stood in the entryway, watching the hallway. Nurses went to and from rooms; an orderly pushed a cart with breakfast trays up the hall, stopping at doors, delivering trays and moving on.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Darin was still on IV. He should have progressed to a liquid diet the night before but hadn’t cooperated enough to sit up and drink. He’d barely regained consciousness and hadn’t known Grant was even in the room, prodding him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Running his fingers through thick black hair that hadn’t yet begun to show the gray that had started to appear on his older brother’s head, Grant rolled his shoulders and sat back down. He’d built extra time into his schedule in case the doctor was late. This wasn’t his first hospital run. He knew how things worked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And Santa Raquel, the coastal California town where he and Darin had settled after Darin’s accident, wasn’t all that big. He could make it across town and to his job site in less than twenty.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Grant?” The deep voice had Grant out of his chair and at the bedside in one second flat.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Right here, bro,” he said, pushing the hair off from his brother’s forehead as he took Darin’s right hand in his and held on. “Just like always.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Darin studied him with eyes that appeared to hold recognition—and more.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How you feeling?” He started out small, not sure what kind of cognition Darin would have left. Or what further damage might have been done.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Head hurts.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You just had surgery.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("just.")]), _vm._v(" I had a night since then.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("With a grin, Grant nudged his brother’s shoulder. “You’re right, bro, you did. And if you’ll cooperate with the nurses today, tonight will be your last one here. You ready to come home?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Darin made a face, scrunching his lips up toward his nose. And did it again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("What the hell was that?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The covers moved above Darin’s left hand. And then moved again. Darin made that face again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nose itches.” Pulling his right hand free from Grant’s clasp, he scratched.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And Grant grinned a second time, letting go of a deep breath. The day before had been slightly alarming, he admitted to himself now that Darin was back. His brother hadn’t come out of the anesthetic as the doctors would have liked—the way he had for all previous surgeries.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He hadn’t really been coherent, either, even when he’d opened his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But Grant had known Darin would make it through just fine.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Still, it was great to—")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good morning.” The tall, gray-haired doctor entered the room. Dr. Zimmer was Grant’s kind of doctor. No-nonsense, tell it like it is. With a nod toward Grant, he focused on Darin. Asked a couple of questions. Slowly. Kindly. Lifting the sheet to look at his brother’s feet, he asked Darin to move his toes. Asked about pain and other sensations. He studied Darin’s eyes, had his brother follow a penlight with his gaze.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Everything was going as expected. Fine. Grant would be out of there soon. He’d get to work on time, come back to spend the evening with Darin and then go home to prepare the house for Darin’s return the next day. All in all, they’d come through the potentially life-threatening episode with only one day of missed work. “Your left hand, Darin. Can you lift your left hand?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Grant watched, nodding, waiting. The covers moved. And...nothing. The left toes had moved. Hadn’t they? Grant hadn’t paid that much attention.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He wanted Dr. Zimmer out of the way so he could check again. Just to make certain.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Moving to the left side of the bed, the surgeon lifted the cover, setting Darin’s hand on top of them. “Now,” he repeated gently. “Move your fingers for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And Darin did.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Thank God.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Lift your hand.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Grant stared. Willed the hand to move. And it did. Okay, not a lot. But the movement meant that Darin was capable, didn’t it? That there was no permanent damage to his brother’s motor skills resulting from the latest surgery?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They’d been through this before. Through worse surgeries. Like the one right after the accident when they’d had to go in to remove the barb the stingray had left in his brother’s brain. Grant had been a senior in college at the time. A mere boy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Darin, once a force to be reckoned with in the business world, had been forever changed. He had his normal moments. And childlike ones. Stress made things worse. He couldn’t figure out basics, like monetary value.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But they’d survived. Made a fine life for themselves. Just the two of them. A satisfactory life. Other guys had wives. Kids. Grant had Darin.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Can I speak with you in the hallway?” Dr. Zimmer’s request interrupted Grant’s silent pep talk. The look on the surgeon’s face put a blight on the positive outlook he’d been trying to create.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll be right back.” Grant squeezed Darin’s hand. “You get ready to spend an hour or two in that chair over there.” He nodded at the high-backed leather seat in the corner by the window. He knew the drill. Darin had to be up, able to walk and get to the bathroom before they’d release him. And it all started with the chair.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I can’t lift my hand, Grant.” Darin’s voice was low. “Why can’t I lift my hand?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Because it’s asleep,” he said, keeping his tone light. Lightness was the last thing Grant felt as he uttered his asinine response and followed the doctor out the door.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-4"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c8438cf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterOne.vue
// module id = 78
// module chunks = 0